import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import {
	formatHtml,
	formatPhoneNumber
} from '../../utils';
import PhoneNumber from '../../../components/phonenumber';

export default class LoginAuthCodeForm extends React.PureComponent {
	render() {
		const {data, phoneNumber, setProperty, otpLogin, reset} = this.props;
		const msg = getPhrase('enterSmsCode').replace('$phone', formatPhoneNumber(phoneNumber));

		return (
			<>
				<h1>{getPhrase('smsAuthentication')}</h1>
				<Form vertical onAction={otpLogin} key="sms">
					<FormHint dangerouslySetInnerHTML={{ __html: formatHtml(msg) }} />
					<FormItem label={getFormItemLabel('smsCode')}>
						<TextInput
							value={data.get('smsCode') || ''}
							maxLength={7}
							textAlign="center"
							onChange={value => setProperty('smsCode', value)}
						/>
					</FormItem>
					<Buttons>
						<Button
							text={getPhrase('login')}
							onAction={otpLogin}
							margin="0px 40px 0px 0px"
							disabled={!data.get('smsCode')}
						/>
						<Button
							text={getPhrase('back')}
							onAction={reset}
							margin="0px"
							type="light"
						/>
					</Buttons>
				</Form>
				<div className="footer">
					<span className="text">{getPhrase('smsNotReceived')}</span>
					<PhoneNumber preset="intergram" />
				</div>
			</>
		);
	}
}

const Buttons = styled.div`
	vertical-align: middle;
	.ps-button[type=light] {
		.text {
			color: ${props => props.theme.textColor};
		}
		&:hover {
			.text {
				text-decoration: underline;
			}
		}
	}
`;

const FormHint = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 40px;
	color: ${props => props.theme.disabledTextColor};
`;
